/**
 * /messages — Phase 4a chat layout route.
 *
 * Auth gate mirrors `routes/board/$projectId.tsx` lines 16-23:
 * no access token → bounce to `/login` before kicking off any API call.
 *
 * The layout pane renders `<MessagesLayout>` which puts the
 * `<ConversationList>` on the left and the route Outlet on the right.
 * The notification banner ships in Phase 4d.
 */

import { Outlet, createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

import { getAccessToken } from '@/auth/cookie-helpers'
import { MessagesLayout } from '@/features/chat/components/MessagesLayout'
import { NotificationsBanner } from '@/features/notifications/components/NotificationsBanner'

export const Route = createFileRoute('/messages')({
  component: MessagesRouteComponent,
})

function MessagesRouteComponent() {
  const navigate = useNavigate()

  useEffect(() => {
    if (!getAccessToken()) {
      navigate({ to: '/login' })
    }
  }, [navigate])

  if (!getAccessToken()) return null

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col">
      <NotificationsBanner />
      <MessagesLayout>
        <Outlet />
      </MessagesLayout>
    </div>
  )
}
